import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon, ClockIcon, BuildingOfficeIcon, ArrowRightIcon } from '@heroicons/react/24/outline';

const VendorRegisterSuccess: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-parchment-50 rtl px-4 py-12">
      <div className="max-w-2xl w-full space-y-6">
        {/* Back to home */}
        <Link
          to="/landing"
          className="inline-flex items-center gap-2 text-sm font-medium text-navy-500 transition-colors hover:text-copper-600"
        >
          <ArrowRightIcon className="h-4 w-4" />
          الرئيسية
        </Link>

        {/* Success Icon */}
        <div className="text-center">
          <div className="mx-auto h-24 w-24 bg-copper-100 rounded-full flex items-center justify-center mb-6">
            <CheckCircleIcon className="h-12 w-12 text-copper-600" />
          </div>
          <h1 className="text-3xl font-bold text-navy-900 mb-4">تم التسجيل بنجاح!</h1>
          <p className="text-lg text-navy-500/80 mb-8">
            شكراً لك على تسجيل مكتبك في نظام إدارة الحج والعمرة
          </p>
        </div>

        {/* Status Card */}
        <div className="bg-white rounded-2xl shadow-lg ring-1 ring-black/5 p-6">
          <div className="flex items-center mb-4">
            <ClockIcon className="h-8 w-8 text-copper-500 ml-3" />
            <h2 className="text-xl font-semibold text-navy-900">حالة الطلب</h2>
          </div>
          
          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 bg-orange-50 rounded-lg border border-orange-200">
              <div className="flex items-center">
                <div className="w-3 h-3 bg-orange-500 rounded-full ml-3"></div>
                <span className="text-orange-800 font-medium">في انتظار المراجعة</span>
              </div>
              <span className="text-sm text-orange-600">قيد المعالجة</span>
            </div>
            
            <p className="text-navy-500/80 text-sm leading-relaxed">
              تم استلام طلب تسجيل مكتبك بنجاح. سيتم مراجعة الطلب من قبل إدارة النظام
              وتفعيل الحساب في أقرب وقت ممكن. ستتلقى إشعاراً عبر البريد الإلكتروني
              عند تفعيل الحساب.
            </p>
          </div>
        </div>

        {/* Next Steps */}
        <div className="bg-white rounded-2xl shadow-lg ring-1 ring-black/5 p-6">
          <h3 className="text-lg font-semibold text-navy-900 mb-4">الخطوات التالية</h3>
          <div className="space-y-3">
            <div className="flex items-start">
              <div className="w-6 h-6 bg-copper-100 rounded-full flex items-center justify-center ml-3 mt-0.5">
                <span className="text-copper-700 text-sm font-medium">1</span>
              </div>
              <div>
                <p className="text-navy-900 font-medium">مراجعة الطلب</p>
                <p className="text-navy-500/80 text-sm">سيتم مراجعة بيانات مكتبك من قبل إدارة النظام</p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="w-6 h-6 bg-copper-100 rounded-full flex items-center justify-center ml-3 mt-0.5">
                <span className="text-copper-700 text-sm font-medium">2</span>
              </div>
              <div>
                <p className="text-navy-900 font-medium">تفعيل الحساب</p>
                <p className="text-navy-500/80 text-sm">سيتم تفعيل حسابك وإرسال إشعار عبر البريد الإلكتروني</p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="w-6 h-6 bg-copper-100 rounded-full flex items-center justify-center ml-3 mt-0.5">
                <span className="text-copper-700 text-sm font-medium">3</span>
              </div>
              <div>
                <p className="text-navy-900 font-medium">بدء الاستخدام</p>
                <p className="text-navy-500/80 text-sm">يمكنك تسجيل الدخول والبدء في استخدام النظام</p>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Info */}
        <div className="bg-parchment-100 rounded-2xl p-6">
          <div className="flex items-center mb-3">
            <BuildingOfficeIcon className="h-6 w-6 text-copper-600 ml-2" />
            <h3 className="text-lg font-semibold text-navy-900">للمساعدة والدعم</h3>
          </div>
          <p className="text-navy-700 text-sm mb-3">
            إذا كان لديك أي استفسارات أو تحتاج إلى مساعدة، لا تتردد في التواصل معنا:
          </p>
          <div className="space-y-2 text-sm text-navy-500/80">
            <p>📧 البريد الإلكتروني: support@hajj-system.com</p>
            <p>📞 الهاتف: +966 50 123 4567</p>
            <p>🕒 ساعات العمل: الأحد - الخميس (8:00 ص - 5:00 م)</p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/landing"
            className="flex-1 bg-navy-900 hover:bg-copper-500 hover:text-navy-900 text-white font-medium py-3 px-6 rounded-lg text-center transition-colors"
          >
            العودة للصفحة الرئيسية
          </Link>

          <Link
            to="/vendor-login"
            className="flex-1 bg-gray-100 hover:bg-gray-200 text-navy-900 font-medium py-3 px-6 rounded-lg text-center transition-colors"
          >
            تسجيل الدخول
          </Link>
        </div>

        {/* Footer */}
        <div className="text-center text-gray-500 text-sm">
          <p>سيتم إرسال تفاصيل تسجيل الدخول إلى بريدك الإلكتروني عند تفعيل الحساب</p>
        </div>
      </div>
    </div>
  );
};

export default VendorRegisterSuccess; 